module.exports = __webpack_public_path__ + "img/room_6.0ba5b529.jpg";